module.exports = __webpack_public_path__ + "img/chiara.08e17982.png";